import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    /* Registro de rubros */
    rubros: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    nombre: '',
    incluirInactivos: false,
    
    rubrosList: [],
    rubrosSelectList: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.rubros = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombre = '';
        state.incluirInactivos = false;
    },

    'INICIALIZAR'(state) {
        state.rubros = [];
    },
    'SET_RUBROS'(state, rubros) {
        state.rubros = rubros;
    },
    'PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LIST'(state) {
        state.rubrosList = [];
        state.rubrosSelectList = [];
    },
    'SET_LIST'(state, params) {
        state.rubrosList = params.rubrosList;
        state.rubrosSelectList = params.rubrosSelectList;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getRubros: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')

            var queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            if (state.nombre != '') {
                queryString += '&nombre=' + state.nombre;
            }
            if (state.incluirInactivos) {
                if (state.incluirInactivos == true || state.incluirInactivos == 'true') {
                    queryString += '&incluirInactivos= true';
                }
            }

            apiAxios.get('rubrostrabajos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('PAGINATION', params);
                    }
                    commit('SET_RUBROS', res.data)

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getRubrosList: ( { commit } ) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get('rubrostrabajos/list')
                .then(res => {
                    let params = {
                        rubrosList: res.data,
                        rubrosSelectList: res.data.map(rubro => rubro.nombre.trim())
                    };
                    commit('SET_LIST', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getRubrosClienteList: ( { commit }, clienteId ) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get(`rubrostrabajos/${clienteId}/list`)
                .then(res => {
                    let params = {
                        rubrosList: res.data,
                        rubrosSelectList: res.data.map(rubro => rubro.nombre.trim())
                    };
                    commit('SET_LIST', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getRubrosArticulosList: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get('rubrostrabajos/list/articulos')
                .then(res => {
                    let rubrosSelectList = [];
                    res.data.forEach(rubro => {
                        rubrosSelectList.push(rubro.nombre.trim());
                    });
                    
                    let params = {
                        rubrosList: res.data,
                        rubrosSelectList
                    };
                    commit('SET_LIST', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },
};

const getters = {
    getField,

    rubrosList (state) {
        return state.rubrosList;
    },
    rubrosSelectList (state) {
        return state.rubrosSelectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}